import Assert from '../utils/Assert';
import MetroCode from './MetroCode';

export default class OnRamp {
  constructor(cloud, marketShare, eqxCenters, totalCenters, metroCode) {
    Assert.isString(cloud);
    Assert.isInteger(eqxCenters);
    Assert.isNumber(marketShare);
    Assert.isInteger(totalCenters);
    Assert.instanceOf(metroCode, MetroCode);

    this.cloud = cloud;
    this.eqxCenters = eqxCenters;
    this.marketShare = marketShare;
    this.totalCenters = totalCenters;
    this.metroCode = metroCode;
    Object.freeze(this);
  }

  equals(other) {
    if (!(other instanceof OnRamp)) {
      return false;
    }

    return this.metroCode.equals(other.metroCode) && this.cloud.equals(other.cloud);
  }

  toString() {
    return `${this.constructor.name}{ cloud:${this.cloud}, metroCode:'${this.metroCode}', eqxCenter:${this.eqxCenter}, marketShare:${this.marketShare}, totalCenters:${this.totalCenters} }`;
  }

  toJSON() {
    const { cloud, marketShare, eqxCenters, totalCenters, metroCode } = this;
    return { cloud, marketShare, eqxCenters, totalCenters, metroCode };
  }

  static fromJSON(json) {
    if (!json) {
      return null;
    }

    const { cloud, marketShare, eqxCenters, totalCenters, metroCode } = json;

    return new OnRamp(cloud, marketShare, eqxCenters, totalCenters, new MetroCode(metroCode));
  }

  static fromJSONArray(jsonArray) {
    if (!jsonArray) {
      return [];
    }

    const items = [];
    for (const json of jsonArray) {
      const p = OnRamp.fromJSON(json);
      items.push(p);
    }

    return items;
  }
}
